<template>
  <page>
    <div>
      <v-flex xs12>
        <form>
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-text-field v-model="filter.subItemNo" :label="label.subItemNo" data-vv-name="subItemNo" :data-vv-as="label.subItemNo" :error-messages="errors.collect('subItemNo')"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" class="mr-2" @click.native="doPrint">
            <span>Print Preview</span>
              <v-icon right dark>mdi-printer</v-icon>
          </v-btn>
          <v-btn color="primary" @click.native="doNew">
            New Package Standard Sub-Item Text<v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-flex>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td class="text-xs-left">{{ row.item.subItemNo }} </td>
                <td class="text-xs-left">{{ row.item.subItemDesc }} </td>
                <td class="table-action-header">
                  <table-action :rowData="row" query @query="doQuery(row.item)" review @review="doReview(row.item)" remove @remove="doPromptRemove(row.item)"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
        <confirm v-model="promptRemove" @ok="doDelete">
          <p>Are you sure you want to delete the Tariff Rate?</p>
          <div class="queryValue">Scheme: {{selected.scheme}}<br/>
            Risk No.: {{selected.riskNo}}<br/>
            Item No.: {{selected.itemNo}}<br/>
            Package Standard Sub-Item No: {{selected.subItemNo}}<br/>
          </div>
         </confirm>
      </v-card>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import clone from 'clone'

export default {
  data() {
    return {
      toogleArray: [false],
      label: {
        pkgStdItemTxtScheme: 'Scheme',
        pkgStdItemTxtRiskNo: 'Risk No.',
        pkgStdItemTxtItemNo: 'Item No.',
        subItemNo: 'Sub-Item No.',
        subItemDesc: 'Sub-Item Description'
      },
      filter: {
        pkgStdItemTxtScheme: null,
        pkgStdItemTxtRiskNo: null,
        pkgStdItemTxtItemNo: null,
        subItemNo: null
      },
      loading: false,
      totalItems: 0,
      headers: [
        { text: 'Sub-Item No.', align: 'left', value: 'subItemNo' },
        { text: 'Sub-Item Description', align: 'left', value: 'subItemDesc' },
        TableConst.tableActionHeader
      ],
      promptRemove: false,
      selected: {
        scheme: null,
        riskNo: null,
        itemNo: null,
        subItemNo: null,
        subItemDesc: null
      },
      dto: {
        scheme: null,
        riskNo: null,
        stdRiskTxtRef: null,
        format: null,
        customName: null,
        sendEmail: null
      },
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  async mounted() {
    await this.$store.dispatch('pkgStdItemTxtInit')
    await this.$store.dispatch('pkgStdSubItemTxtInit')
    this.doInit()
  },
  methods: {
    async doInit() {
      this.fetchData(true)
    },
    async fetchData(options) {
      const apiURI = this.menu.getPkgStdSubItemTxtList
      this.filter.pkgStdItemTxtScheme = this.pkgStdItemTxtId.scheme
      this.filter.pkgStdItemTxtRiskNo = this.pkgStdItemTxtId.riskNo
      this.filter.pkgStdItemTxtItemNo = this.pkgStdItemTxtId.itemNo
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filter, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  scheme: datamap.scheme,
                  riskNo: datamap.riskNo,
                  itemNo: datamap.itemNo,
                  subItemNo: datamap.subItemNo,
                  subItemDesc: datamap.subItemDesc
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.filter.subItemNo = null
      this.fetchData(false)
    },
    doFilters() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doNew() {
      const commit = {
        tranMode: 'New',
        scheme: this.pkgStdItemTxtId.scheme,
        riskNo: this.pkgStdItemTxtId.riskNo,
        itemNo: this.pkgStdItemTxtId.itemNo,
        subItemNo: null,
        subItemDesc: null
      }
      sessionStorage.setItem('pkgStdSubItemTxt', JSON.stringify(commit))
      this.$store.commit('PKGSTDSUBITEMTXT_COMMIT_KEY', commit)
      this.$router.push({ name: 'pkgStdSubItemTxtReview' })
    },
    doQuery(data) {
      const commit = {
        tranMode: 'Query',
        scheme: data.scheme,
        riskNo: data.riskNo,
        itemNo: data.itemNo,
        subItemNo: data.subItemNo,
        subItemDesc: data.subItemDesc
      }
      sessionStorage.setItem('pkgStdSubItemTxt', JSON.stringify(commit))
      this.$store.commit('PKGSTDSUBITEMTXT_COMMIT_KEY', commit)
      this.$router.push({ name: 'pkgStdSubItemTxtReview' })
    },
    doReview(data) {
      const commit = {
        tranMode: 'Review',
        scheme: data.scheme,
        riskNo: data.riskNo,
        itemNo: data.itemNo,
        subItemNo: data.subItemNo,
        subItemDesc: data.subItemDesc
      }
      sessionStorage.setItem('pkgStdSubItemTxt', JSON.stringify(commit))
      this.$store.commit('PKGSTDSUBITEMTXT_COMMIT_KEY', commit)
      this.$router.push({ name: 'pkgStdSubItemTxtReview' })
    },
    async doPromptRemove(data) {
      if (data) {
        this.selected.scheme = data.scheme
        this.selected.riskNo = data.riskNo
        this.selected.itemNo = data.itemNo
        this.selected.subItemNo = data.subItemNo
        this.selected.subItemDesc = data.subItemDesc
        this.promptRemove = true
      }
    },
    async doDelete() {
      this.resetMessages()
      if (this.selected && this.selected.itemNo) {
        const apiURI = this.menu.deletePkgStdSubItemTxt
        if (apiURI) {
          const expand = {
            scheme: this.selected.scheme,
            riskNo: this.selected.riskNo,
            itemNo: this.selected.itemNo,
            subItemNo: this.selected.subItemNo,
            subItemDesc: this.selected.subItemDesc
          }
          this.$http
            .post(apiURI, expand)
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.fetchData(false)
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    async doPrint() {
      this.doExport()
    },
    async doExport() {
      const apiURI = this.menu.exportPkgStdSubItemTxtRpt
      if (apiURI) {
        try {
          this.dto.scheme = this.filter.pkgStdItemTxtScheme
          this.dto.riskNo = this.filter.pkgStdItemTxtRiskNo
          this.dto.stdRiskTxtRef = this.pkgStdItemTxtId.stdRiskTxtRef
          this.dto.format = 'PDF'
          this.dto.customName = ''
          this.dto.sendEmail = false
          let messageFilters = clone(this.dto)
          await this.$http.post(apiURI, messageFilters)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  created() {
    const jsonData = JSON.parse(sessionStorage.getItem('pkgStdItemTxt'))
    this.$store.commit('PKGSTDITEMTXT_COMMIT_KEY', jsonData)
  },
  computed: {
    menu() {
      return this.$store.state.pkgParam.pkgStdSubItemTxt.menu
    },
    pkgStdItemTxtId() {
      return this.$store.state.pkgParam.pkgStdItemTxt.pkgStdItemTxtId
    }
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  mixins: [TableConst.default, MessageMixin, commonAjaxMixin]
}
</script>
